import { NativeModule } from 'expo-modules-core';
export default class FileSystemShim extends NativeModule {
    documentDirectory = null;
    cacheDirectory = null;
    bundleDirectory = null;
}

//# sourceMappingURL=ExponentFileSystemShim.js.map
